module.exports = function (modal, id, $el, cookieExpiration) {
    var $modal = $(modal);

    var $successCTA = $modal.find('.popup-modal__cta--success').first();
    var $dismissCTA = $modal.find('.popup-modal__cta--dismiss').first();

    $successCTA.click(function (e) {
        ICF.Modules.PopupModal.SetPopupCookie(id, cookieExpiration);
        ICF.Modules.PopupModal.ClosePopup($el);
    });

    $dismissCTA.click(function (e) {
        e.preventDefault();
        ICF.Modules.PopupModal.ClosePopup($el);
    });
};